import store from '../store'

export function getBoxAbsolutePosition(boxId) {
    const captions = store.getState().slideReducer.captions
    const workspace = document.getElementById(`workspace`).getBoundingClientRect()
    const boxIndex = _.findIndex(captions, { id: boxId })
    let boxInDom = document.getElementById(`caption-${boxIndex}`).getBoundingClientRect()
    boxInDom.x -= workspace.x
    boxInDom.y -= workspace.y

    return { x: boxInDom.x, y: boxInDom.y }
}

// export function convertToRelativePosition(boxId, position) {

//     position.relativeX = boxInDom.x - position.x
//     position.relativeY = boxInDom.y - position.y

//     return position
// }

// export function convertToAbsolutePosition(boxId, position) {

//     position.x = boxInDom.x + position.x
//     position.y = boxInDom.y + position.y

//     return position
// }

export function getOpacityForBoxBorder(backgroundColor, borderColor) {
    const regex = /(\d+(\.\d+)?\))/;
    const opacityBackground = backgroundColor.match(regex)[0]
    const opacityBorder = borderColor.match(regex)[0]
    borderColor = borderColor.replace(opacityBorder, opacityBackground)

    return borderColor
}
